import React, { useState } from "react";
import "./Header.css";
import logo from "./logo.png";
import { Link } from "react-router-dom";

const Header = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeAllDropdowns = () => {
    setActiveDropdown(null);
  };

  return (
    <>
      <div class="top-bar">
        <div class="top-bar-container">
          <div class="top-bar-message">
            🏆 We Won The Best AI Solutions Provider of the year 2024-25
          </div>
          <div class="top-bar-contact">
            <span class="top-bar-email">
              Customer Support E-mail: cs@mketech.in / help@mketech.in
            </span>
            <span class="top-bar-phone">Support: +91 2269710459</span>
            <span class="top-bar-phone">Sales: +91 9155599968</span>
          </div>
        </div>
      </div>

      <header className="header">
        <div className="header-container">
          <div className="brand">
            <a
              href="/"
              className="brand-link"
              aria-label="e-Tech Pvt. Ltd Home"
            >
              <div className="logo">
                <img
                  src={logo}
                  alt="MK e-Tech Pvt. Ltd"
                  className="logo-image"
                />
              </div>

              {/* Attractive AI badge */}
              <span className="ai-badge" aria-hidden="false">
                <span className="ai-letter a">A</span>
                <span className="ai-letter i">i</span>
              </span>
            </a>
          </div>

          <nav className="nav-menu">
            <ul className="nav-list">
              <li className="nav-item">
                <a href="/home" className="nav-link">
                  Home
                </a>
              </li>

              {/* Services Dropdown */}
              <li
                className={`nav-item dropdown ${
                  activeDropdown === "services" ? "active" : ""
                }`}
                onMouseEnter={() => toggleDropdown("services")}
                onMouseLeave={closeAllDropdowns}
              >
                <span className="nav-link">
                  Services <span className="dropdown-icon">▼</span>
                </span>
                <div className="dropdown-menu services-dropdown">
                  <div className="dropdown-grid">
                    <a href="/technology-practices" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-tech"></i>
                      </div>
                      <span>Technology Practices</span>
                    </a>
                    <a href="/digital-commerce" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-ecommerce"></i>
                      </div>
                      <span>Digital Marketing</span>
                    </a>
                    <a href="software-product" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-software"></i>
                      </div>
                      <span>Software Product</span>
                    </a>
                    <a href="/cloud-infrastructure" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-cloud"></i>
                      </div>
                      <span>Cloud & Infrastructure</span>
                    </a>
                    <a href="/dev-sec-ops" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-devops"></i>
                      </div>
                      <span>DevSecOps</span>
                    </a>
                    <a
                      href="/digital-quality-assurance"
                      className="dropdown-item"
                    >
                      <div className="dropdown-icon-box">
                        <i className="icon-qa"></i>
                      </div>
                      <span>Digital Quality Assurance</span>
                    </a>
                    <a href="/offering" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-offerings"></i>
                      </div>
                      <span>Offerings</span>
                    </a>
                    <a href="/generative-ai" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-ai"></i>
                      </div>
                      <span>Generative AI</span>
                    </a>
                    <a href="/cx-infrastructure" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-cx"></i>
                      </div>
                      <span>CX Infrastructure</span>
                    </a>
                    <a href="/intelligent-automation" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-automation"></i>
                      </div>
                      <span>Intelligent Automation</span>
                    </a>
                    <a
                      href="/application-development-management"
                      className="dropdown-item"
                    >
                      <div className="dropdown-icon-box">
                        <i className="icon-appdev"></i>
                      </div>
                      <span>Application Development & Management</span>
                    </a>
                    <a href="/training" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-training"></i>
                      </div>
                      <span>Training</span>
                    </a>
                    <a href="/private-equity" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-equity"></i>
                      </div>
                      <span>Private Equity</span>
                    </a>
                    <a
                      href="/private-equity-services"
                      className="dropdown-item"
                    >
                      <div className="dropdown-icon-box">
                        <i className="icon-equity-services"></i>
                      </div>
                      <span>Private Equity Services</span>
                    </a>
                    <a href="/enterprise-integration" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-integration"></i>
                      </div>
                      <span>Enterprise Integrations</span>
                    </a>
                    <a href="/enterprise-it-security" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-security"></i>
                      </div>
                      <span>Enterprise IT Security</span>
                    </a>
                    <a href="/data-analytics" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-analytics"></i>
                      </div>
                      <span>Data and Analytics</span>
                    </a>
                    <a href="/mobile" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-mobile"></i>
                      </div>
                      <span>Mobile</span>
                    </a>
                  </div>
                </div>
              </li>

              {/* Industries Dropdown */}
              <li
                className={`nav-item dropdown ${
                  activeDropdown === "industries" ? "active" : ""
                }`}
                onMouseEnter={() => toggleDropdown("industries")}
                onMouseLeave={closeAllDropdowns}
              >
                <span className="nav-link">
                  Industries <span className="dropdown-icon">▼</span>
                </span>
                <div className="dropdown-menu industries-dropdown">
                  <div className="dropdown-grid">
                    <a href="/fintech" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-finance"></i>
                      </div>
                      <span>Fintech</span>
                    </a>
                    <a href="/real-estate" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-building"></i>
                      </div>
                      <span>Real Estate</span>
                    </a>
                    <a href="/banking" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-bank"></i>
                      </div>
                      <span>Banking</span>
                    </a>
                    <a href="/pharma" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-medicine"></i>
                      </div>
                      <span>Pharma</span>
                    </a>
                    <a href="/health-care" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-health"></i>
                      </div>
                      <span>Healthcare</span>
                    </a>
                    <a href="/welfare" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-welfare"></i>
                      </div>
                      <span>Welfare</span>
                    </a>
                    <a href="/art" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-art"></i>
                      </div>
                      <span>Art</span>
                    </a>
                    <a href="/insurance" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-insurance"></i>
                      </div>
                      <span>Insurance</span>
                    </a>
                    <a href="/government" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-government"></i>
                      </div>
                      <span>Government</span>
                    </a>
                    <a href="/entertainment" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-entertainment"></i>
                      </div>
                      <span>Entertainment</span>
                    </a>
                    <a href="/gaming" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-gaming"></i>
                      </div>
                      <span>Gaming</span>
                    </a>
                    <a href="/energy" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-energy"></i>
                      </div>
                      <span>Energy</span>
                    </a>
                  </div>
                </div>
              </li>

              {/* Resources Dropdown */}
              <li
                className={`nav-item dropdown ${
                  activeDropdown === "resources" ? "active" : ""
                }`}
                onMouseEnter={() => toggleDropdown("resources")}
                onMouseLeave={closeAllDropdowns}
              >
                <span className="nav-link">
                  Resources <span className="dropdown-icon">▼</span>
                </span>
                <div className="dropdown-menu resources-dropdown">
                  <div className="dropdown-grid">
                    <a href="/blog" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-blog"></i>
                      </div>
                      <span>Blog</span>
                    </a>
                  </div>
                </div>
              </li>

              {/* Investors Dropdown */}
              <li
                className={`nav-item dropdown ${
                  activeDropdown === "investors" ? "active" : ""
                }`}
                onMouseEnter={() => toggleDropdown("investors")}
                onMouseLeave={closeAllDropdowns}
              >
                <span className="nav-link">
                  Investors <span className="dropdown-icon">▼</span>
                </span>
                <div className="dropdown-menu investors-dropdown">
                  <div className="dropdown-grid">
                    <a href="/presentations" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-presentation"></i>
                      </div>
                      <span>Presentations</span>
                    </a>
                    <a href="/financials" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-financial"></i>
                      </div>
                      <span>Financials</span>
                    </a>
                    <a href="/annual-reports" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-report"></i>
                      </div>
                      <span>Annual Reports</span>
                    </a>
                    <a href="/company-announcements" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-announcement"></i>
                      </div>
                      <span>Company Announcement</span>
                    </a>
                    <a href="/corporate-governance" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-governance"></i>
                      </div>
                      <span>Corporate Governance</span>
                    </a>
                    <a href="/shareholding-pattern" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-shares"></i>
                      </div>
                      <span>Shareholding Pattern</span>
                    </a>
                    <a href="/market-tracker" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-market"></i>
                      </div>
                      <span>Market Tracker</span>
                    </a>
                    <a
                      href="/investor-form/information"
                      className="dropdown-item"
                    >
                      <div className="dropdown-icon-box">
                        <i className="icon-form"></i>
                      </div>
                      <span>Investor Form/Information</span>
                    </a>
                    <a
                      href="/investor-contact-details"
                      className="dropdown-item"
                    >
                      <div className="dropdown-icon-box">
                        <i className="icon-contact"></i>
                      </div>
                      <span>Investor Contact Details</span>
                    </a>
                  </div>
                </div>
              </li>

              {/* Careers Dropdown */}
              <li
                className={`nav-item dropdown ${
                  activeDropdown === "careers" ? "active" : ""
                }`}
                onMouseEnter={() => toggleDropdown("careers")}
                onMouseLeave={closeAllDropdowns}
              >
                <span className="nav-link">
                  Careers <span className="dropdown-icon">▼</span>
                </span>
                <div className="dropdown-menu careers-dropdown">
                  <div className="dropdown-grid">
                    <a href="/send-cv" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-cv"></i>
                      </div>
                      <span>Send CV</span>
                    </a>
                    <a href="/internship-program" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-intern"></i>
                      </div>
                      <span>Internship Program</span>
                    </a>
                    <a href="/current-open-position" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-jobs"></i>
                      </div>
                      <span>Current Open Positions</span>
                    </a>
                    <a href="/why-join-us" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-why-join"></i>
                      </div>
                      <span>Why Join Us</span>
                    </a>
                    <a href="/employee-testimonials" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-testimonials"></i>
                      </div>
                      <span>Employee Testimonials</span>
                    </a>
                  </div>
                </div>
              </li>

              {/* Company Dropdown */}
              <li
                className={`nav-item dropdown ${
                  activeDropdown === "company" ? "active" : ""
                }`}
                onMouseEnter={() => toggleDropdown("company")}
                onMouseLeave={closeAllDropdowns}
              >
                <span className="nav-link">
                  Company <span className="dropdown-icon">▼</span>
                </span>
                <div className="dropdown-menu company-dropdown">
                  <div className="dropdown-grid">
                    <a href="/about" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-about"></i>
                      </div>
                      <span>About</span>
                    </a>
                    <a href="/corporate-value" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-values"></i>
                      </div>
                      <span>Corporate Value</span>
                    </a>
                    <a href="/news" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-news"></i>
                      </div>
                      <span>News</span>
                    </a>
                    <a href="/health-tech" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-healthtech"></i>
                      </div>
                      <span>HealthTech</span>
                    </a>
                    <a href="/retails-manufacturing" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-retail"></i>
                      </div>
                      <span>Retail and Manufacturing</span>
                    </a>
                    <a href="/gallery" className="dropdown-item">
                      <div className="dropdown-icon-box">
                        <i className="icon-gallery"></i>
                      </div>
                      <span>Gallery</span>
                    </a>
                  </div>
                </div>
              </li>

              <li className="nav-item">
                <a href="/tools-tech-stack" className="nav-link">
                  Tools & Tech Stack
                </a>
              </li>
              <li className="nav-item">
                <a href="/contact-us" className="nav-link">
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <div className="mobile-menu-btn" onClick={toggleMobileMenu}>
            <div className={`hamburger ${mobileMenuOpen ? "open" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-menu-content">
            <a href="/" className="mobile-menu-item" onClick={toggleMobileMenu}>
              Home
            </a>

            <div className="mobile-menu-dropdown">
              <div
                className="mobile-menu-header"
                onClick={() => toggleDropdown("mobile-services")}
              >
                <span>Services</span>
                <span className="dropdown-icon">
                  {activeDropdown === "mobile-services" ? "▲" : "▼"}
                </span>
              </div>
              <div
                className={`mobile-dropdown-content ${
                  activeDropdown === "mobile-services" ? "active" : ""
                }`}
              >
                <div className="mobile-dropdown-scroll">
                  <a
                    href="/technology-practices"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Technology Practices
                  </a>
                  <a
                    href="/digital-commerce"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Digital Marketing
                  </a>
                  <a
                    href="/software-product"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Software Product
                  </a>
                  <a
                    href="/cloud-infrastructure"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Cloud & Infrastructure
                  </a>
                  <a
                    href="/dev-sec-ops"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    DevSecOps
                  </a>
                  <a
                    href="/digital-quality-assurance"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Digital Quality Assurance
                  </a>
                  <a
                    href="/offering"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Offerings
                  </a>
                  <a
                    href="generative-ai"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Generative AI
                  </a>
                  <a
                    href="/cx-infrastructure"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    CX Infrastructure
                  </a>
                  <a
                    href="/intelligent-automation"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Intelligent Automation
                  </a>
                  <a
                    href="/application-development-management"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Application Development & Management
                  </a>
                  <a
                    href="/training"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Training
                  </a>
                  <a
                    href="/private-equity"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Private Equity
                  </a>
                  <a
                    href="/private-equity-services"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Private Equity Services
                  </a>
                  <a
                    href="/enterprise-integration"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Enterprise Integrations
                  </a>
                  <a
                    href="/enterprise-it-security"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Enterprise IT Security
                  </a>
                  <a
                    href="/data-analytics"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Data and Analytics
                  </a>
                  <a
                    href="/mobile"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Mobile
                  </a>
                </div>
              </div>
            </div>

            <div className="mobile-menu-dropdown">
              <div
                className="mobile-menu-header"
                onClick={() => toggleDropdown("mobile-industries")}
              >
                <span>Industries</span>
                <span className="dropdown-icon">
                  {activeDropdown === "mobile-industries" ? "▲" : "▼"}
                </span>
              </div>
              <div
                className={`mobile-dropdown-content ${
                  activeDropdown === "mobile-industries" ? "active" : ""
                }`}
              >
                <div className="mobile-dropdown-scroll">
                  <a
                    href="/fintech"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Fintech
                  </a>
                  <a
                    href="/real-estate"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Real Estate
                  </a>
                  <a
                    href="/banking"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Banking
                  </a>
                  <a
                    href="/pharma"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Pharma
                  </a>
                  <a
                    href="/health-care"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Healthcare
                  </a>
                  <a
                    href="/welfare"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Welfare
                  </a>
                  <a
                    href="/art"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Art
                  </a>
                  <a
                    href="/insurance"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Insurance
                  </a>
                  <a
                    href="/government"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Government
                  </a>
                  <a
                    href="/entertainment"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Entertainment
                  </a>
                  <a
                    href="/gaming"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Gaming
                  </a>
                </div>
              </div>
            </div>

            <div className="mobile-menu-dropdown">
              <div
                className="mobile-menu-header"
                onClick={() => toggleDropdown("mobile-resources")}
              >
                <span>Resources</span>
                <span className="dropdown-icon">
                  {activeDropdown === "mobile-resources" ? "▲" : "▼"}
                </span>
              </div>
              <div
                className={`mobile-dropdown-content ${
                  activeDropdown === "mobile-resources" ? "active" : ""
                }`}
              >
                <div className="mobile-dropdown-scroll">
                  <a
                    href="/blog"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Blog
                  </a>
                </div>
              </div>
            </div>

            <div className="mobile-menu-dropdown">
              <div
                className="mobile-menu-header"
                onClick={() => toggleDropdown("mobile-investors")}
              >
                <span>Investors</span>
                <span className="dropdown-icon">
                  {activeDropdown === "mobile-investors" ? "▲" : "▼"}
                </span>
              </div>
              <div
                className={`mobile-dropdown-content ${
                  activeDropdown === "mobile-investors" ? "active" : ""
                }`}
              >
                <div className="mobile-dropdown-scroll">
                  <a
                    href="/presentations"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Presentations
                  </a>
                  <a
                    href="/financials"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Financials
                  </a>
                  <a
                    href="/annual-reports"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Annual Reports
                  </a>
                  <a
                    href="/company-announcements"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Company Announcement
                  </a>
                  <a
                    href="/corporate-governance"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Corporate Governance
                  </a>
                  <a
                    href="/shareholding-pattern"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Shareholding Pattern
                  </a>
                  <a
                    href="/market-tracker"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Market Tracker
                  </a>
                  <a
                    href="/investor-form/information"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Investor Form/Information
                  </a>
                  <a
                    href="/investor-contact-details"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Investor Contact Details
                  </a>
                </div>
              </div>
            </div>

            <div className="mobile-menu-dropdown">
              <div
                className="mobile-menu-header"
                onClick={() => toggleDropdown("mobile-careers")}
              >
                <span>Careers</span>
                <span className="dropdown-icon">
                  {activeDropdown === "mobile-careers" ? "▲" : "▼"}
                </span>
              </div>
              <div
                className={`mobile-dropdown-content ${
                  activeDropdown === "mobile-careers" ? "active" : ""
                }`}
              >
                <div className="mobile-dropdown-scroll">
                  <a
                    href="/send-cv"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Send CV
                  </a>
                  <a
                    href="/internship-program"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Internship Program
                  </a>
                  <a
                    href="/current-open-position"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Current Open Positions
                  </a>
                  <a
                    href="/why-join-us"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Why Join Us
                  </a>
                  <a
                    href="/employee-testimonials"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Employee Testimonials
                  </a>
                </div>
              </div>
            </div>

            <div className="mobile-menu-dropdown">
              <div
                className="mobile-menu-header"
                onClick={() => toggleDropdown("mobile-company")}
              >
                <span>Company</span>
                <span className="dropdown-icon">
                  {activeDropdown === "mobile-company" ? "▲" : "▼"}
                </span>
              </div>
              <div
                className={`mobile-dropdown-content ${
                  activeDropdown === "mobile-company" ? "active" : ""
                }`}
              >
                <div className="mobile-dropdown-scroll">
                  <a
                    href="/about"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    About
                  </a>
                  <a
                    href="/corporate-value"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Corporate Value
                  </a>
                  <a
                    href="/news"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    News
                  </a>
                  <a
                    href="/health-tech"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    HealthTech
                  </a>
                  <a
                    href="/retails-manufacturing"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Retail and Manufacturing
                  </a>
                   <a
                    href="/gallery"
                    className="mobile-dropdown-item"
                    onClick={toggleMobileMenu}
                  >
                    Gallery
                  </a>
                </div>
              </div>
            </div>

            <a
              href="/tools-tech-stack"
              className="mobile-menu-item"
              onClick={toggleMobileMenu}
            >
              Tools & Tech Stack
            </a>
            <a
              href="/contact-us"
              className="mobile-menu-item"
              onClick={toggleMobileMenu}
            >
              Contact Us
            </a>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
